import { cn } from "@/lib/cn";

export interface TypingIndicatorProps {
  className?: string;
}

export function TypingIndicator({ className }: TypingIndicatorProps) {
  return (
    <div
      className={cn("flex w-full justify-start", className)}
      data-testid="typing-indicator"
    >
      <div className="flex max-w-[80%] items-center gap-1.5 rounded-2xl rounded-bl-md border border-border bg-surface px-4 py-3">
        <span
          className="h-2 w-2 animate-bounce rounded-full bg-text-muted"
          style={{ animationDelay: "0ms" }}
        />
        <span
          className="h-2 w-2 animate-bounce rounded-full bg-text-muted"
          style={{ animationDelay: "150ms" }}
        />
        <span
          className="h-2 w-2 animate-bounce rounded-full bg-text-muted"
          style={{ animationDelay: "300ms" }}
        />
      </div>
    </div>
  );
}
